var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompilation = function SvgCompilation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#compilation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAEAE9",
    fillRule: "evenodd",
    d: "M16 6.361v-4.5C16 1.387 15.486 1 14.857 1H1.143C.514 1 0 1.387 0 1.86v4.501c0 .474.514.861 1.143.861h13.714c.629 0 1.143-.387 1.143-.86m0 7.112V9.178c0-.474-.514-.861-1.143-.861H1.143c-.629 0-1.143.387-1.143.86v4.296c0 .473.514.86 1.143.86h13.714c.629 0 1.143-.387 1.143-.86M4.832 4.108a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.388 9.003a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compilation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCompilation;